import React, { createContext, useContext } from "react";

export interface LayoutShellValue {
  isMobile: boolean;
  mobileNavOpen: boolean;
  setMobileNavOpen: (open: boolean) => void;
  desktopCollapsed: boolean;
  toggleDesktopNav: () => void;
}

export const LayoutShellContext = createContext<LayoutShellValue | null>(null);

export function useLayoutShell(): LayoutShellValue | null {
  return useContext(LayoutShellContext);
}
